module.exports = __webpack_public_path__ + "img/doc.308232b7.svg";